/* eslint-disable camelcase */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Typograf from 'typograf';

import { LocaleContext } from 'app/containers/LocaleProvider';

import { formatDeliveryDateMobile, formatInterval } from 'app/utils/date';
import ArrowIcon from './arrow.component.svg';

import { locales } from './deliveryDate.locales';

import './delivery-date-mobile.scss';


const tp = new Typograf({ locale: ['ru', 'en-US'] });


const DeliveryDateMobile = (props) => {
    const {
        selectDay = null,
        timeIntervals = null,
        isDisabledInfoHidden = false,
        disabled = false,
        isTimeChange = false,
        isMobileShowMessageOnTimeChange = false,
        isDayChangedAnimation = false,
        isTimeChangedAnimation = false,
        onEndDayAnimation = () => {},
        onEndTimeAnimation = () => {},

        applyNYStyles = false,
        selectTime: { timeIndex } = {},
        selectedInterval: {
            hourFrom,
            hourTo,
            minuteFrom,
            minuteTo,
            hour_from,
            minute_from,
            hour_to,
            minute_to,
        } = {},
        onClickDates,
        onClickTimeIntervals,
        isDaySelectDisabled,
        isTimeSelectDisabled,
    } = props;

    const { locale } = useContext(LocaleContext);

    const l = locales[locale];

    const timeChanedText = l.timeChangedText;
    const disabledText = l.disabled;

    const hf = hourFrom || hour_from;
    const ht = hourTo || hour_to;
    const mf = minuteFrom || minute_from;
    const mt = minuteTo || minute_to;

    const activeShowTime = timeIntervals
        ? timeIntervals[timeIndex]
        : formatInterval(hf, ht, mf, mt);


    const selectButtonDayClasses = classNames({
        'select-button': true,
        disabled: isDaySelectDisabled,
        dayAnimationEnter: isDayChangedAnimation,
    });
    const selectButtonTimeClasses = classNames({
        'select-button': true,
        disabled: isTimeSelectDisabled,
        timeAnimationEnter: isTimeChangedAnimation,
    });

    const { day, weekday, month } = selectDay ? formatDeliveryDateMobile(selectDay, locale) : { day: '', weekday: '', month: '' };

    const isNeededRenderDisabledInfo = !isDisabledInfoHidden && disabled;

    const selectToggleClasses = classNames({
        'select-toggle': true,
        'new-year': applyNYStyles,
    });

    return (
        <>
            <div styleName="select">
                <button
                    type="button"
                    styleName={selectButtonDayClasses}
                    onClick={onClickDates}
                    onAnimationEnd={onEndDayAnimation}
                    disabled={isDaySelectDisabled}
                >
                    <div styleName="select-value">
                        <div styleName="select-date">
                            <div styleName="select-date__weekday">{weekday}</div>
                            {selectDay ? (
                                <div styleName="select-date__day">
                                    {day}
                                    /
                                    {month}
                                </div>
                            ) : (
                                <div styleName="select-date__day" />
                            )}
                        </div>
                    </div>
                    <div styleName={selectToggleClasses}>
                        <div styleName="select-toggle-icon"><ArrowIcon /></div>
                    </div>
                </button>
                <button
                    type="button"
                    styleName={selectButtonTimeClasses}
                    onClick={onClickTimeIntervals}
                    onAnimationEnd={onEndTimeAnimation}
                    disabled={isTimeSelectDisabled}
                >
                    <div styleName="select-value">
                        <div styleName="select-time">
                            <div styleName="select-time__interval">
                                {activeShowTime && `${activeShowTime.start} - ${activeShowTime.end}`}
                            </div>
                        </div>
                    </div>
                    <div styleName={selectToggleClasses}>
                        <div styleName="select-toggle-icon"><ArrowIcon /></div>
                    </div>
                </button>
            </div>
            {isTimeChange && isMobileShowMessageOnTimeChange && (
                <div styleName="select__date-time-info red">
                    {tp.execute(timeChanedText)}
                </div>
            )}
            {isNeededRenderDisabledInfo && (
                <div styleName="select__date-time-info">
                    {tp.execute(disabledText)}
                </div>
            )}
        </>
    );
};

export default DeliveryDateMobile;

DeliveryDateMobile.propTypes = {
    timeIntervals: PropTypes.arrayOf(PropTypes.shape({})),
    selectDay: PropTypes.string,
    selectTime: PropTypes.shape({
        timePeriod: PropTypes.string,
        timeIndex: PropTypes.number,
    }),
    selectedInterval: PropTypes.shape({
        hourFrom: PropTypes.number,
        hourTo: PropTypes.number,
    }),
    onClickDates: PropTypes.func.isRequired,
    onClickTimeIntervals: PropTypes.func.isRequired,
    isDisabledInfoHidden: PropTypes.bool,
    disabled: PropTypes.bool,
    isTimeChange: PropTypes.bool,
    isMobileShowMessageOnTimeChange: PropTypes.bool,
    isDayChangedAnimation: PropTypes.bool,
    isTimeChangedAnimation: PropTypes.bool,
    onEndDayAnimation: PropTypes.func,
    onEndTimeAnimation: PropTypes.func,

    applyNYStyles: PropTypes.bool,
};
